import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const ReplikaRelationshipsStyles = styled(OnboardingPage)`
  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 0 26px;
    }

    .img-container {
      display: flex;
      align-items: center;
      flex-grow: 1;
      width: 100%;
      padding: 20px 20px 0;
      margin: 0 auto;

      @media screen and (min-width: 576px) {
        max-width: 350px;
      }

      img {
        width: 100%;
      }
    }
  }
`;
